/**
 * SECTION - COOPERATION
 */

import RouteSelector from "../containers/RouteSelector";
import { views } from "./../services/constants";

const { cooperate } = views;

const CooperationRoutes = {
  routes: [
    /*{
      path: ["/cooperation", "/cooperacao"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperation"
      }
    },
    {
      path: ["/cooperation-areas", "/areas-cooperacao"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationAreas"
      }
    },
    {
      path: ["/portfolio", "/portefolio"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "portfolio"
      }
    },
    {
      path: ["/entrepreneurship", "/empreendedorismo"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "entrepreneurship"
      }
    },
    {
      path: ["/creative-science-park", "/parque-ciencia-inovacao"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "creativeSciencePark"
      }
    },
    {
      path: ["/cooperation-support", "/balcao-cooperacao"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationSupport"
      }
    },
    {
      path: ["/impacto-regiao", "/regional-influence"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "regionalInfluence"
      }
    }*/
  ]
};

export default CooperationRoutes;
